module.exports = __webpack_public_path__ + "static/img/合照3.8dea655.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezhao/合照3.jpg
// module id = hulO
// module chunks = 1